/**
 * 261030 B1-fix1 — nhớ bản ảnh nào sinh bằng PROMPT TAY (Custom Prompt) để lúc bấm «Dùng» báo BE ghi nguồn «ảnh của người» (máy không gen đè).
 * Trước đây là `useRef` của composer ⇒ đóng composer rồi mở lại là mất. Nay: Set cấp module (sống qua đóng/mở composer) + sessionStorage (sống qua tải lại trang).
 * Mọi truy cập storage bọc try/catch — không có storage vẫn chạy bằng Set trong bộ nhớ.
 */
const KEY = 'tb.customVariantIds.v1';
const MAX = 200;
const memory = new Set<string>();
let loaded = false;

function load(): void {
  if (loaded) return;
  loaded = true;
  try {
    const raw = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(KEY) : null;
    const list = raw ? JSON.parse(raw) : [];
    if (Array.isArray(list)) for (const id of list) if (typeof id === 'string') memory.add(id);
  } catch { /* storage không dùng được ⇒ chỉ giữ trong bộ nhớ */ }
}
function save(): void {
  try {
    if (typeof sessionStorage !== 'undefined') sessionStorage.setItem(KEY, JSON.stringify(Array.from(memory).slice(-MAX)));
  } catch { /* bỏ qua */ }
}

/** Đánh dấu bản vừa sinh bằng prompt tay. */
export function markCustomVariant(variantId: string): void {
  load();
  memory.add(variantId);
  if (memory.size > MAX) for (const id of Array.from(memory).slice(0, memory.size - MAX)) memory.delete(id);
  save();
}
export function isCustomVariant(variantId: string): boolean {
  load();
  return memory.has(variantId);
}
/** Chỉ cho test. */
export function resetCustomVariantMarksForTest(): void { memory.clear(); loaded = false; try { if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(KEY); } catch { /* bỏ qua */ } }
/** Chỉ cho test: giả lập tải lại trang (mất bộ nhớ, còn storage). */
export function dropCustomVariantMemoryForTest(): void { memory.clear(); loaded = false; }
